// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-bar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* width: 100%; */
    margin: 3px 10px;
    background-color: rgba(51, 51, 51, 0.7);
    /* Low opacity background */
    color: white;
    /* White text color */
    height: 3.5vh;
}


.timeline-bar-controls {
    display: flex;
    align-items: center;
    font-size: 1.5em;

    button {
        background-color: rgba(85, 85, 85, 0);
        border: none;
        color: white;
        padding: 5px 10px;
        cursor: pointer;
        border-radius: 4px;
    }

    @media (min-width: 769px) {
        button:hover {
            background-color: rgba(119, 119, 119, 0.9);
        }
    }
    
    .multiplier {
        font-size: 1.6em;
        padding: 4px;
    }
}


.current-time {
    font-size: 1.6em;
}`, "",{"version":3,"sources":["webpack://./src/burnair/modules/timeline/timeLineBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,2BAA2B;IAC3B,YAAY;IACZ,qBAAqB;IACrB,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;;IAEhB;QACI,qCAAqC;QACrC,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI;YACI,0CAA0C;QAC9C;IACJ;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;AACJ;;;AAGA;IACI,gBAAgB;AACpB","sourcesContent":[".timeline-bar-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /* width: 100%; */\n    margin: 3px 10px;\n    background-color: rgba(51, 51, 51, 0.7);\n    /* Low opacity background */\n    color: white;\n    /* White text color */\n    height: 3.5vh;\n}\n\n\n.timeline-bar-controls {\n    display: flex;\n    align-items: center;\n    font-size: 1.5em;\n\n    button {\n        background-color: rgba(85, 85, 85, 0);\n        border: none;\n        color: white;\n        padding: 5px 10px;\n        cursor: pointer;\n        border-radius: 4px;\n    }\n\n    @media (min-width: 769px) {\n        button:hover {\n            background-color: rgba(119, 119, 119, 0.9);\n        }\n    }\n    \n    .multiplier {\n        font-size: 1.6em;\n        padding: 4px;\n    }\n}\n\n\n.current-time {\n    font-size: 1.6em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
